import PlusIcon from 'iconsax-react/dist/esm/Add';
import React from 'react';
import { TDR } from 'tdr-common';
import X from '../../icons/x.svg';
import {
	ImageCard,
	ImageCardAsset,
	ImageCardDescription,
	ImageCardFooter,
	ImageCardHeader,
	ImageCardHeaderPrimary,
	ImageCardHeaderSecondary,
	ImageCardHeaderTitle
} from '../image-card/ImageCard';
import AddOnPriceLabel from '../price-label/AddOnPriceLabel';

export type SelectableEcommerceProduct = {
	id: string;
	title: string;
	tag: string;
	description?: string;
	variantId: string;
	isSignatureItem: boolean;
	unit: string;
	price: {
		amount: number;
		unit: string;
	};
	imageUrl: string;
};

type SelectableEcommerceItemProps = {
	product: SelectableEcommerceProduct;
	restaurant: TDR.Restaurant;
	onSelect: (id: string, variantId: string) => void;
	isSelected: boolean;
};

export const SelectableEcommerceItem = ({ product, restaurant, onSelect, isSelected }: SelectableEcommerceItemProps) => {
	const handleSelect = () => {
		onSelect(product.id, product.variantId);
	};
	const [showDescription, setShowDescription] = React.useState(false);

	const handleInfoClick = () => {
		setShowDescription(!showDescription);
	};

	return (
		<div
			className={`flex flex-col gap-4 cursor-pointer transition-all duration-200 ease-in-out m-1 ${
				isSelected
					? 'border-2 border-[#A8813A] rounded-xl p-1'
					: 'hover:border-2 hover:border-[#A8813A] hover:rounded-xl hover:p-1'
			}`}
			onClick={handleSelect}
		>
			<ImageCard height={416}>
				<ImageCardAsset src={product.imageUrl} alt={product.title} />

				<ImageCardHeader>
					<ImageCardHeaderPrimary>
						<ImageCardHeaderTitle>{product.title}</ImageCardHeaderTitle>
					</ImageCardHeaderPrimary>

					<ImageCardHeaderSecondary onClick={handleInfoClick}>
						{showDescription ? 'Close' : 'Info'}
						{showDescription ? <img src={X} alt='Close button' /> : <PlusIcon />}
					</ImageCardHeaderSecondary>
				</ImageCardHeader>

				<ImageCardDescription isVisible={showDescription}>
					<p>{product.description}</p>
				</ImageCardDescription>

				{product.tag && (
					<ImageCardFooter>
						<span>{product.tag?.toUpperCase()}</span>
					</ImageCardFooter>
				)}
			</ImageCard>

			<div className="flex justify-between items-center">
				<AddOnPriceLabel
					priceAmount={product.price.amount}
					currency={restaurant.currency}
					displayUnit={product.unit}
					isSignatureProduct={product.isSignatureItem}
				/>
				<div className="flex items-center">
					{isSelected && (
						<div className="flex items-center gap-2">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="12" cy="12" r="12" fill="#00AB55"/>
								<path d="M7 12.5L10.5 16L17 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
							<span className="text-base font-medium mr-2 text-green-500">Selected</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
